import { useMemo } from 'react';
import styled from 'styled-components';
import ColoredSpan from '../basics/ColoredSpan';
import DropdownButton from '../basics/DropdownButton';
import ProjectionIcon from '../icons/ProjectionIcon';

// Shows a dropdown button and value for the currently selected metric
const MetricSelect = styled(
  ({
    color,
    options,
    selectedOption,
    setOption,
    className,
    value, // The metric value to display
    info, // A short string to show after the value, like "(Avg/yr)"
  }) => {
    const optionsWithSelected = useMemo(
      () =>
        options.map((o) => ({
          ...o,
          // Don't show the selected option as disabled
          disabled: o.name === selectedOption ? false : o.disabled,
        })),
      [options, selectedOption],
    );
    return (
      <div className={className}>
        <div className="d-flex align-items-center">
          <ColoredSpan color={color}>
            <ProjectionIcon />
          </ColoredSpan>
          <DropdownButton
            options={optionsWithSelected}
            placeholder={selectedOption}
            selectedOption={selectedOption}
            color="link"
            setOption={setOption}
            className="px-1 text-dark"
            showCheckmark
          />
        </div>
        <div className="d-flex align-items-baseline">
          <div className="font-xl ml-3">{value}</div>
          {info && (
            <span className="font-tiny font-italic text-muted ml-1">
              {info}
            </span>
          )}
        </div>
      </div>
    );
  },
)`
  min-width: 150px;
`;

export default MetricSelect;
